export default __webpack_public_path__ + "static/media/TriangleShadingO.4d691031.png";